import * as React from 'react';
import { t } from '@moovly/i18n';
import { IconEdit, IconTrash } from '@moovly/ui';
import { GroupInfo } from '@moovly/clients/lib/resources/group/group.interfaces';
import { formatDate } from '../../../../utils/date';
import {
  Table,
  TableBody,
  TableCol,
  TableHeadCol,
  TableHeader,
  TableRow,
  TableLoader,
  TableAction,
} from '../../../../components/Table';
import { Link } from 'react-router-dom';

export interface ExtendedGroupInfo extends GroupInfo {
  totalUsers: number;
}

interface GroupsTableProps {
  groups: ExtendedGroupInfo[];
  isLoading?: boolean;
  onEdit: (group: GroupInfo) => void;
  onDelete: (group: GroupInfo) => void;
}

const GroupsTable: React.FC<GroupsTableProps> = ({ groups, isLoading = false, onEdit, onDelete }) => {
  const handleEdit = React.useCallback((gr: GroupInfo) => () => onEdit(gr), [onEdit]);
  const handleDelete = React.useCallback((gr: GroupInfo) => () => onDelete(gr), [onDelete]);

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeadCol>{t('groups.table.name')}</TableHeadCol>
            <TableHeadCol>{t('groups.table.createdAt')}</TableHeadCol>
            <TableHeadCol>{t('groups.table.users')}</TableHeadCol>
            <TableHeadCol>{t('groups.table.admins')}</TableHeadCol>
            <TableHeadCol>{t('groups.table.actions')}</TableHeadCol>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groups.map((gr) => (
            <TableRow>
              <TableCol>
                <Link to={`/users?group=${gr.id}`}>{gr.name}</Link>
              </TableCol>
              <TableCol>{formatDate(gr.created_at)}</TableCol>
              <TableCol>{gr.totalUsers}</TableCol>
              <TableCol>{gr.admins.length}</TableCol>
              <TableCol>
                <div className="d-flex flex-row">
                  <TableAction onClick={handleEdit(gr)} icon={IconEdit} />
                  <TableAction onClick={handleDelete(gr)} icon={IconTrash} />
                </div>
              </TableCol>
            </TableRow>
          ))}
          {isLoading && <TableLoader columnns={3} rows={3} />}
        </TableBody>
      </Table>
    </>
  );
};

export default GroupsTable;
